/** Agency CRM client accounts that can log in and view assigned campaigns/screens. */
export const CLIENT_ROLE = 'CLIENT';

export const PERSONAL_ADVERTISER_ROLE = 'PERSONAL_ADVERTISER';

export const AD_AGENCY_ROLE = 'AD_AGENCY';

export const AD_AGENCY_SUB_ACCOUNT_ROLE = 'AD_AGENCY_SUB_ACCOUNT';

function normalizeRole(role?: string | null): string {
  return String(role || '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '_');
}

export function isClientRole(role?: string | null): boolean {
  const key = normalizeRole(role);
  return key === CLIENT_ROLE || key === 'AD_AGENCY_CLIENT';
}

export function isAgencyRole(role?: string | null): boolean {
  return normalizeRole(role) === AD_AGENCY_ROLE;
}

export function isTeamMemberRole(role?: string | null): boolean {
  return normalizeRole(role) === AD_AGENCY_SUB_ACCOUNT_ROLE;
}

/** Agency or team member — both pick a CLIENT when creating campaigns. */
export function requiresAgencyClient(role?: string | null): boolean {
  return isAgencyRole(role) || isTeamMemberRole(role);
}

/** Signup URL that pre-selects Personal Advertiser. */
export function personalAdvertiserSignupPath(): string {
  return `/signup?accountType=${PERSONAL_ADVERTISER_ROLE}`;
}
